module.exports = __webpack_public_path__ + "static/photo-2-c3df488167eea7be03f2ddf4785ccde7.jpg";